import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
export function sortBy(predicate, items) {
  var itemsCopy = _toConsumableArray(items);

  itemsCopy.sort(predicate);
  return itemsCopy;
}